import { render } from "./FacultyCurriculum.vue?vue&type=template&id=9a099716"
import script from "./FacultyCurriculum.vue?vue&type=script&lang=js"
export * from "./FacultyCurriculum.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__